import { render, staticRenderFns } from "./allReportsCO.vue?vue&type=template&id=5c83b5bf&scoped=true"
import script from "./allReportsCO.vue?vue&type=script&lang=js"
export * from "./allReportsCO.vue?vue&type=script&lang=js"
import style0 from "./allReportsCO.vue?vue&type=style&index=0&id=5c83b5bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83b5bf",
  null
  
)

export default component.exports